export default { version: 'latest' };
